// π ----
// :: MODULES BOOTSTRAP ---------------------------::
// ____

/* :: Imports
---------------------------------- */

import animate from './partials/components/animations';
import topics_list from './partials/components/topics_list';
import hero from './partials/modules/hero';
import header from './partials/modules/header';
import header_avatar from './partials/modules/header_avatar';
import campaign from './partials/modules/campaign';
import featured_download from './partials/blocks/featured_download';
import testimonials from './partials/blocks/testimonials';
import cards_slider from './partials/blocks/cards_slider';
import logo_slideshow from './partials/blocks/logo_slideshow';
import modals from './partials/components/modals';
import navigation from './core/navigation';
import page from './views/page';
import singledownload from './views/singledownload';
import scrolling_sections from './partials/blocks/scrolling_sections';
import on_page_nav from './partials/blocks/on_page_nav';
import video from './partials/blocks/video';
import group_leaders_logout from './partials/components/group_leaders_logout';
import dropdowns from './partials/components/jquery.prettydropdowns';

import leader_application from './apps/leader_application';
import imf from './apps/imf';
import metrics from './apps/metrics';

export default {
    init() {
        animate.init();
        campaign.init();
    },
    finalize() {
        header.init();
        header_avatar.init();
        navigation.init();
        hero.init();
        video.init();
        testimonials.init();
        cards_slider.init();
        logo_slideshow.init();
        group_leaders_logout.init();
        leader_application.init();
        imf.init();
        metrics.init();
    }
};
